import {
    Alert,
    Button,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { refundTransaction } from '../../api';

export default function RefundModal({ isOpen, onClose, transaction, isARB }) {
    const [amount, setAmount] = useState(transaction.initialCharge || '');
    const [loading, setLoading] = useState(false);
    const toast = useToast();

    const handleRefund = async () => {
        if (!amount) return;
        setLoading(true);

        const res = await refundTransaction({
            transactionId: transaction.transactionId,
            amount,
            last4: transaction.cardLast4
        });


        setLoading(false);
        if (res.success) {
            toast({ title: 'Refund Successful', status: 'success', duration: 3000 });
            onClose();
        } else {
            toast({ title: res.error, status: 'error', duration: 3000 });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Refund Transaction</ModalHeader>
                <ModalCloseButton />
                <ModalBody>

                    {isARB != null &&

                        <Alert flexDir={'column'} mt={3} mb={3}>
                            <Text>This transaction is part of ARB subscription, refunding this transaction won't cancel the ARB subscription.</Text>
                            <Text mt={3}>To cancel a whole subscription, you need to void/refund this transaction and go to View ARB details and cancel it from there.</Text>
                        </Alert>

                    }

                    <Text mb={2}>Enter amount to refund:</Text>
                    <Input
                        placeholder="Amount"
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} mr={3} disabled={loading}>Cancel</Button>
                    <Button colorScheme="red" onClick={handleRefund} isLoading={loading}>
                        Confirm Refund
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
